import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { InvitationGuard } from '@/components/auth/InvitationGuard';

export default function ProtectedRoute() {
  const { credentials } = useAuthStore();
  const location = useLocation();

  const isAuthenticated = !!credentials;

  if (!isAuthenticated) {
    console.log('ProtectedRoute: User not authenticated, redirecting to login.');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <InvitationGuard />
      <Outlet />
    </>
  );
}
